import React from "react";
import tw from "twin.macro";
import { useDispatch, useSelector } from "react-redux";
import { CardsReducer } from "./Redux/CardsSlice";
import { TableReducer } from "./Redux/TableSlice";

const Container = tw.div` flex justify-center items-center`;
const CardsContainer = tw.div`flex flex-wrap justify-center`;
const Cards = tw.div`md:w-1/4 m-8 p-6 border border-gray-400 bg-white rounded-2xl overflow-hidden`;
const ImageContainer = tw.div`h-1/2 w-full `;
const DetailsContainer = tw.div`w-full  `;
const Detail = tw.div`my-2`;
const FlexContainer = tw.div`flex  w-full items-center justify-between `;

const Paragraph = tw.h5`text-base font-semibold   truncate  `;
const Heading = tw.h5`text-xl font-bold  truncate  `;
const Subheading = tw.h5`text-base font-semibold   truncate  `;

const ButtonContainer = tw.div`text-center border-t border-gray-400 mt-6 pt-2`;
const Button = tw.a`cursor-pointer text-xl font-semibold`;

export default () => {
  const SeeMoreFn = () => {
    dispatch(CardsReducer(2));

    dispatch(TableReducer(0));
  };

  const dispatch = useDispatch();

  return (
    <Container>
      <CardsContainer>
        <Cards>
          <FlexContainer>
            <DetailsContainer>
              <Detail>
                <Heading>Machine Name</Heading>
              </Detail>

              <Detail>
                <Subheading>Location </Subheading>
                <Heading>Area Name</Heading>
              </Detail>

              <FlexContainer>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
              </FlexContainer>

              <Detail>
                <Subheading>Product Status </Subheading>
                <Heading>25</Heading>
              </Detail>

              <ButtonContainer onClick={() => console.log("Hello")}>
                <Button onClick={() => SeeMoreFn()}>See More</Button>
              </ButtonContainer>
            </DetailsContainer>
          </FlexContainer>
        </Cards>

        <Cards>
          <FlexContainer>
            <DetailsContainer>
              <Detail>
                <Heading>Machine Name</Heading>
              </Detail>

              <Detail>
                <Subheading>Location </Subheading>
                <Heading>Area Name</Heading>
              </Detail>

              <FlexContainer>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
              </FlexContainer>

              <Detail>
                <Subheading>Product Status </Subheading>
                <Heading>25</Heading>
              </Detail>

              <ButtonContainer onClick={() => console.log("Hello")}>
                <Button onClick={() => SeeMoreFn()}>See More</Button>
              </ButtonContainer>
            </DetailsContainer>
          </FlexContainer>
        </Cards>

        <Cards>
          <FlexContainer>
            <DetailsContainer>
              <Detail>
                <Heading>Machine Name</Heading>
              </Detail>

              <Detail>
                <Subheading>Location </Subheading>
                <Heading>Area Name</Heading>
              </Detail>

              <FlexContainer>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
              </FlexContainer>

              <Detail>
                <Subheading>Product Status </Subheading>
                <Heading>25</Heading>
              </Detail>

              <ButtonContainer onClick={() => console.log("Hello")}>
                <Button onClick={() => SeeMoreFn()}>See More</Button>
              </ButtonContainer>
            </DetailsContainer>
          </FlexContainer>
        </Cards>

        <Cards>
          <FlexContainer>
            <DetailsContainer>
              <Detail>
                <Heading>Machine Name</Heading>
              </Detail>

              <Detail>
                <Subheading>Location </Subheading>
                <Heading>Area Name</Heading>
              </Detail>

              <FlexContainer>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
              </FlexContainer>

              <Detail>
                <Subheading>Product Status </Subheading>
                <Heading>25</Heading>
              </Detail>

              <ButtonContainer onClick={() => console.log("Hello")}>
                <Button onClick={() => SeeMoreFn()}>See More</Button>
              </ButtonContainer>
            </DetailsContainer>
          </FlexContainer>
        </Cards>

        <Cards>
          <FlexContainer>
            <DetailsContainer>
              <Detail>
                <Heading>Machine Name</Heading>
              </Detail>

              <Detail>
                <Subheading>Location </Subheading>
                <Heading>Area Name</Heading>
              </Detail>

              <FlexContainer>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
              </FlexContainer>

              <Detail>
                <Subheading>Product Status </Subheading>
                <Heading>25</Heading>
              </Detail>

              <ButtonContainer onClick={() => console.log("Hello")}>
                <Button onClick={() => SeeMoreFn()}>See More</Button>
              </ButtonContainer>
            </DetailsContainer>
          </FlexContainer>
        </Cards>

        <Cards>
          <FlexContainer>
            <DetailsContainer>
              <Detail>
                <Heading>Machine Name</Heading>
              </Detail>

              <Detail>
                <Subheading>Location </Subheading>
                <Heading>Area Name</Heading>
              </Detail>

              <FlexContainer>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
                <Detail>
                  <Subheading>Machine Status </Subheading>
                  <Heading>25</Heading>
                </Detail>
              </FlexContainer>

              <Detail>
                <Subheading>Product Status </Subheading>
                <Heading>25</Heading>
              </Detail>

              <ButtonContainer onClick={() => console.log("Hello")}>
                <Button onClick={() => SeeMoreFn()}>See More</Button>
              </ButtonContainer>
            </DetailsContainer>
          </FlexContainer>
        </Cards>
      </CardsContainer>
    </Container>
  );
};
